@if (infoText() && !isInPopup()) {
  <button
    (click)="iconClicked()"
    [attr.aria-label]="'shared.furtherInformation' | translate: { term: infoText().title }"
    [attr.title]="'shared.furtherInformation' | translate: { term: infoText().title }"
    class="btn btn-em btn-link--orange ml-1 {{ colorClass() }}"
    type="button"
    aria-haspopup="dialog"
  >
    <i [attr.data-test]="dataTest()" class="fas fa-info-circle fa-w-16 pointer my-auto"></i>
  </button>
}
